<div class="modal-header">
    <h5 class="modal-title">{{ headerLabel }}</h5>
    <button type="button" class="close" (click)="activeModal.close()"><span>×</span></button>
</div>
<div class="modal-body">
    <p>{{ messageLabel }}</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger btn-sm" (click)="activeModal.close('ok')">Ok</button>
    <button type="button" class="btn btn-secondary btn-sm" (click)="activeModal.close()">Cancel</button>
</div>
